module.exports = __webpack_public_path__ + "img/ltkplussize-1x.9f2ad94.jpg";